<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import { isCurrentPage } from '@/utilities/path'

/**
 * @fileoverview
 *  機能と DOM のみの準ヘッドレスコンポーネントです。
 *  実際に利用する際は、ラッパーコンポーネントを用意し、deep オブション付きのスタイルを定義した上での運用を想定しており、
 *  よってこのコンポーネントのみでの使用はできません。
 * @example /app/frontend/components/tab/TabDefault.vue
 */
export default defineComponent({
  name: 'TabCore',

  props: {
    items: {
      type: Object as PropType<TabItem[]>,
      required: true,
    },

    /**
     * 現在ページのタブ item key
     */
    currentTabKey: {
      type: String,
      default: '',
    },
  },

  emits: ['click'],

  setup(props) {
    /**
     * 現在ページに該当するタブの key を算出する
     */
    const computedCurrentTabKey = computed<string>(() => {
      return props.currentTabKey || props.items.find(v => {
        return v.to && isCurrentPage(v.to)
      })?.key || ''
    })

    return {
      computedCurrentTabKey,
    }
  }
})
</script>

<template>
  <!--
    タブの CSS は外側から deep style で注入する
    @see https://qiita.com/olt/items/7da218af89d563c7c7a0
  -->
  <div class="o-list__tab">
    <ul class="o-list__tab--items">
      <template
        v-for="item in items"
        :key="item.key">
        <!--
          各タブ item の isShow プロパティは、明示的に注入されなかった場合（undefined）は「表示」する。
          状態によってタブの項目が変動する場合のみ、isShow プロパティを明示的に注入することで、表示制御として評価される。
        -->
        <li
          v-if="item.isShow || item.isShow === undefined"
          class="o-list__tab--item">
          <!-- current 表示 -->
          <template v-if="item.key === computedCurrentTabKey">
            <div class="o-label__tab">
              <p class="o-label__tab--item">
                {{ item.label }}
              </p>
            <!-- /.o-label__tab --></div>
          </template>

          <!-- リンク -->
          <template v-else>
            <div class="o-action__tab">
              <a
                v-if="item.to"
                class="o-action__tab--item"
                :href="item.to">
                {{ item.label }}
              </a>
              <button
                v-else
                class="o-action__tab--item"
                @click.prevent="$emit('click', item.key)">
                {{ item.label }}
              </button>
            <!-- /.o-action__tab --></div>
          </template>
        </li>
      </template>
    </ul>
  <!-- /.o-list__tab --></div>
</template>
